// Bootstrap pattern for Module Federation
// This allows async loading of shared modules before app initialization
import('./bootstrap');

export {};
